{
    "AgentList_AddButton_DisabledTooltip": "Selecteer een telefonieserver en partitie in de bovenstaande filters om een ​​agent toe te voegen.",
    "AgentList_Column_AgentNumber": "Agentnummer",
    "AgentList_Column_PartitionId": "Partitie-ID",
    "AgentList_Column_Monitored": "Gecontroleerd",
    "AgentList_Monitored_Yes": "Ja",
    "AgentList_Monitored_No": "Nee",
    "AgentList_Column_Description": "Beschrijving",
    "AgentList_Column_InternalNumber": "Intern nummer",
    "AgentList_Column_PartitionName": "Partitienaam",
    "AgentList_Column_OmniChannel": "Omni-channel",
    "NAME": "AgentListLanguage"
}